import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IonicPageModule } from 'ionic-angular';
import { ShopperBuySocialPayPage } from './shopper-buy-social-pay';

@NgModule({
  declarations: [
    ShopperBuySocialPayPage,
  ],
  imports: [
    IonicPageModule.forChild(ShopperBuySocialPayPage),
    TranslateModule.forChild()
  ],
})
export class ShopperBuySocialPayPageModule {}



// WEBPACK FOOTER //
// ./src/pages/shopper-buy-social-pay/shopper-buy-social-pay.module.ts